import { create } from 'zustand';

export type QuickButton = { id: number | 'MAX' | 'CUSTOM'; value: number | null };

export type EventStore = {
    selectedTab: number;
    actions: {
        setSelectedTab: (tab: number) => void;
    };
};

export const useEventsTabsStore = create<EventStore>()(set => ({
    selectedTab: 0,
    actions: {
        setSelectedTab: tab => {
            set({ selectedTab: tab });
        },
    },
}));
